export default ({
    name : 'HamburgerMenuLayer'
    , props : {
    }
    , data () {
        return {
            noticeUrl : '/notice'
            , qnaUrl : '/qna'
        }
    },
    created () {
        let footerData = this.getDetailDataByCode('common_footer');
        if (footerData.data.biz_info != undefined) {
            this.bizInfo = footerData.data.biz_info;
        }
        if (footerData.data.shop_info != undefined) {
            this.shopInfo = footerData.data.shop_info;
        }
        this.notice = this.getDetailDataByCode('notice');
        this.qna = this.getDetailDataByCode('qna');
        return {}
    },
    computed : {
        isUseShopBizHours () {
            return (this.isSetShopInfo() && this.shopInfo.shop_biz_hours.value.length > 0)
        }
        , isUseShopPhone () {
            return (this.isSetShopInfo() && this.shopInfo.shop_phone.value.length > 0)
        }
        , isUseShopEmail () {
            return (this.isSetShopInfo() && this.shopInfo.shop_email.value.length > 0)
        }
        , shopBizHours () {
            return this.shopInfo.shop_biz_hours.value;
        }
        , shopPhone () {
            return this.shopInfo.shop_phone.value;
        }
        , shopEmail () {
            return this.shopInfo.shop_email.value;
        }
        , linkShopPhone () {
            return "tel:" + this.shopInfo.shop_phone.value;
        }
        , linkShopEmail () {
            return "mailto:" + this.shopInfo.shop_email.value;
        }
        , displayNotice() {
            return this.isSetNotice() ? this.notice.displayNotice : false;
        }
        , noticeListLink() {
            return (this.notice.displayNotice) ? this.noticeUrl : '';
        }
        , displayQna() {
            return this.isSetQna() ? this.qna.displayQna : false;
        }
        , qnaLink() {
            return (this.qna.displayQna) ? this.qnaUrl : '';
        }
    }
    , methods : {
        isSetShopInfo () {
            return (typeof this.shopInfo != 'undefined')
        }
        , isSetNotice () {
            return ((typeof this.notice != 'undefined') && this.notice.displayNotice)
        }
        , isSetQna () {
            return ((typeof this.qna != 'undefined') && this.qna.displayQna)
        }
    }
})
